module.exports = __webpack_public_path__ + "static/img/lenovo-service2.ed19914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lenovo-service2.png
// module id = 4zmK
// module chunks = 1 15 16 17 18 19